import uuid from 'uuid-random';
import { addPopupAction, LAYER } from 'js/components/common/PopupManager';

import * as Types from '../types';
import { TermsConditionsConfirmationPopup } from '../TermsConditionsConfirmationPopup';

export const termsConditionsConfirmationPopupId = uuid();

export const showTermsConditionsConfirmationPopupAction = ({
    id,
    onAccept,
    onDecline,
    tcVersion,
    isModal = true,
    closeAll = true,
    layer = LAYER.HIGH_PRIORITY
}: Types.ITermsConditionsConfirmationPopupProps) => addPopupAction({
    closeAll,
    isModal,
    id: id ?? termsConditionsConfirmationPopupId,
    layer,
    component: TermsConditionsConfirmationPopup,
    onAccept,
    onDecline,
    tcVersion
});
